import { Text } from '@capsicum/common-web';
import styled from 'styled-components';
import { type RuleSet } from 'styled-components/dist/types';

export type TransactionSectionHeaderProps = {
	containerStyle?: RuleSet<object>;
	leftText: string;
	rightText?: string;
	subTitleStyle?: RuleSet<object>;
};

export const TransactionSectionHeader = ({
	containerStyle,
	leftText,
	rightText,
	subTitleStyle
}: TransactionSectionHeaderProps) => {
	return (
		<S.Container $containerStyle={containerStyle}>
			<S.SubTitle $subTitleStyle={subTitleStyle}>
				<S.LeftText variant="text5">{leftText}</S.LeftText>
			</S.SubTitle>
			{rightText && (
				<S.SubTitle>
					<S.TextStyled variant="text5">{rightText}</S.TextStyled>
				</S.SubTitle>
			)}
		</S.Container>
	);
};

namespace S {
	export const Container = styled.div<{ $containerStyle?: RuleSet<object> }>`
		padding: 0 ${({ theme }) => theme.spacings.small} 0;
		flex-direction: row;
		justify-content: space-between;
		${({ $containerStyle }) => $containerStyle};
	`;

	export const TextStyled = styled(Text)`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		text-align: left;
		height: 18px;
	`;

	export const LeftText = styled(TextStyled)`
		text-transform: uppercase;
	`;

	export const SubTitle = styled.div<{ $subTitleStyle?: RuleSet<object> }>`
		margin: ${({ theme }) => theme.spacings.small} 0 ${({ theme }) => theme.spacings.small};

		${({ $subTitleStyle }) => $subTitleStyle};
	`;
}
